import {Stack, Typography} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import {useActiveField} from "../../store/activeFieldStore";
import {FieldIcon} from "../icons/FieldIcon";

export const ParcelHeader: React.FC = () => {
    const field = useActiveField();
    const parcelName = field?.name?.split("_")[0] ?? field?.name;

    return (
        <Stack direction="column" gap="1rem">
            <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Stack direction="row" alignItems="center" gap="1.125rem">
                    {field && (
                        <FieldIcon
                            sx={{
                                width: "1.6rem",
                                height: "1.6rem",
                                stroke: "#5161C1",
                                strokeWidth: "2.2",
                            }}
                        />
                    )}
                    {!field && (
                        <ErrorIcon
                            sx={{
                                height: 36,
                                width: 36,
                            }}
                            color="error"
                        />
                    )}
                    <Typography fontSize={30} lineHeight={1.27} fontWeight={700}>
                        {parcelName}
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};
